import { useCustomMutation } from '@refinedev/core';
import { UseFormReturnType } from '@mantine/form';
import { FormValuesType } from 'src/UI/dynamicUI/types';
import { Logger } from 'src/utils/Logger';

type ValidationResponse = {
  is_duplicate: boolean;
};

export const useValidateProviderReference = (clientId: string) => {
  const { mutateAsync, isLoading, isError, error } = useCustomMutation<ValidationResponse>();

  const validateProviderReference = async (providerReferenceNumber: string, assetId?: string) => {
    const result = await mutateAsync({
      method: 'post',
      url: `clients/${clientId}/assets/validate-provider-reference`,
      values: {
        provider_reference_number: providerReferenceNumber,
        ...(assetId && { asset_id: assetId }),
      },
    });
    return result;
  };

  return {
    validateProviderReference,
    isLoading,
    isError,
    error,
  };
};

export const validateProviderReferenceAndSetError = async (
  productData: Record<string, unknown>,
  clientId: string,
  form: UseFormReturnType<FormValuesType>,
  productConstant: string,
  validateProviderReference: (
    ref: string,
    assetId?: string,
  ) => Promise<{ data: ValidationResponse }>,
): Promise<boolean> => {
  if (productData?.provider_reference_number && clientId) {
    try {
      const result = await validateProviderReference(
        String(productData.provider_reference_number),
        productData['id'] as string | undefined,
      );
      if (result.data.is_duplicate) {
        form.setFieldError(
          `${productConstant}.provider_reference_number`,
          'This provider reference number is already in use',
        );
        return false;
      }
    } catch (error) {
      Logger.warn('Provider reference validation failed', { error });
    }
  }
  return true;
};
